import { generatePath, useHistory } from 'react-router-dom';
import { AppPath, RouterLinkParams } from '../routes/pages';

const useGoToPage = (
  path: AppPath | string,
  params?: RouterLinkParams
): (() => void | null) => {
  const history = useHistory();
  if (!path) return null;
  if (!history) return null;
  return () => history.push(generatePath(path, params));
};

export default useGoToPage;
